"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _globalComponentsLibrary = require("global-components-library");
var _reactI18next = require("react-i18next");
require("./ContactInfo.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ContactInfo = function ContactInfo(_ref) {
  var phoneNumber = _ref.phoneNumber,
    data = _ref.data,
    onClose = _ref.onClose,
    onUnassign = _ref.onUnassign,
    onFinish = _ref.onFinish;
  var _useTranslation = (0, _reactI18next.useTranslation)(['contact-info', 'header', 'commons']),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDialogOpen = _useState2[0],
    setDialogOpen = _useState2[1];
  var dialogData = (0, _react.useRef)({});
  var openDialog = function openDialog(action, type) {
    dialogData.current = {
      action: action,
      type: type
    };
    setDialogOpen(true);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-conv-contact-info"
  }, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon clickable close",
    onClick: onClose
  }), t('title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-contact-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-contact-title"
  }, /*#__PURE__*/_react["default"].createElement("b", null, t('phone')), /*#__PURE__*/_react["default"].createElement("span", null, phoneNumber)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-contact-info"
  }, /*#__PURE__*/_react["default"].createElement("b", null, t('data')), data.map(function (d, i) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: i
    }, d);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-contact-actions"
  }, onUnassign && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
    onClick: function onClick() {
      return openDialog(onUnassign, 'unassign');
    }
  }, t('unassign')), onFinish && /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
    onClick: function onClick() {
      return openDialog(onFinish, 'finish');
    }
  }, t('finish')))), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DialogBox, {
    show: isDialogOpen,
    toggle: function toggle() {
      return setDialogOpen(!isDialogOpen);
    },
    onAccept: dialogData.current.action,
    title: t('header:' + dialogData.current.type + '.title'),
    content: t('header:' + dialogData.current.type + '.content'),
    accept: t('header:' + dialogData.current.type + '.commit'),
    cancel: t('commons:cancel')
  }));
};
ContactInfo.propTypes = {
  phoneNumber: _propTypes["default"].string,
  data: _propTypes["default"].array,
  onClose: _propTypes["default"].func.isRequired,
  onUnassign: _propTypes["default"].func,
  onFinish: _propTypes["default"].func
};
ContactInfo.defaultProps = {
  data: []
};
var _default = exports["default"] = ContactInfo;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationView/ContactInfo/ContactInfo.js
// module id = 1403
// module chunks = 0